import { Button, Typography } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { UploadSourceModal } from '@features/upload-source';

const { Title, Text } = Typography;

interface Props {
  assistantId: string;
  onBack: () => void;
}

/**
 * Состояние «Добавить документ».
 *
 * MVP-заглушка (Пакет 1):
 *  - Открывает существующую UploadSourceModal — фича работает как раньше
 *  - В Пакете 2 будет полноценная inline-форма с drag-and-drop
 *    и батч-подтверждением для множественной загрузки
 *
 * При закрытии модалки возвращаемся в welcome (через onBack), чтобы
 * юзер увидел свежую карточку в списке слева.
 */
export function AddDocumentState({ assistantId, onBack }: Props) {
  const [modalOpen, setModalOpen] = useState(false);

  // Открываем модалку сразу при входе в состояние — пока не переписали
  // на inline-форму, это самое прозрачное поведение.
  useEffect(() => {
    setModalOpen(true);
  }, []);

  const handleClose = () => {
    setModalOpen(false);
    onBack();
  };

  return (
    <div style={{ padding: 24 }}>
      <Button type="text" icon={<ArrowLeftOutlined />} onClick={onBack} style={{ marginBottom: 16 }}>
        Назад
      </Button>

      <Title level={4} style={{ marginTop: 0 }}>
        Загрузка документа
      </Title>
      <Text type="secondary">
        Поддерживаются PDF, DOCX, PPTX, XLSX, TXT — до 100 МБ каждый.
      </Text>

      <UploadSourceModal
        open={modalOpen}
        assistantId={assistantId}
        onClose={handleClose}
      />
    </div>
  );
}
